//环境变量(dev test feat feat2 prod)
const env = process.env.REACT_APP_ENV;

// 接口域名
const apiConfig = {
  dev: {
    sso: '//sso-dev.corp.36kr.com/api'
  },
  test: {
    sso: '//sso-test.corp.36kr.com/api'
  },
  feat: {
    sso: '//sso-feat.corp.36kr.com/api'
  },
  feat2: {
    sso: '//sso-feat2.corp.36kr.com/api'
  },
  pre: {
    sso: '//sso-pre.corp.36kr.com/api'
  },
  prod: {
    sso: '//sso.corp.36kr.com/api'
  }
};

// 访问域名
const urlConfig  = {
  dev: {
    sso: '//sso-dev.corp.36kr.com'
  },
  test: {
    sso: '//sso-test.corp.36kr.com'
  },
  feat: {
    sso: '//sso-feat.corp.36kr.com'
  },
  feat2: {
    sso: '//sso-feat2.corp.36kr.com'
  },
  pre: {
    sso: '//sso-pre.corp.36kr.com'
  },
  prod: {
    sso: '//sso.corp.36kr.com'
  }
};

export const api = apiConfig[env];
export const url = urlConfig[env];
